import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { ApplicationTypes } from 'src/app/services/util.enum';
import { menuData } from 'src/app/STORE/selectors/menu.selector';

@Component({
  selector: 'vb-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
  standalone: false  //NOSONAR
})
export class SideBarComponent implements OnInit {
  private store = inject(Store);
  private appGlobalService = inject(AppGlobalService);
  private cdr = inject(ChangeDetectorRef);

  sidebarItems$: Observable<any>;

  ngOnInit() {
    this.sidebarItems$ = this.store.select(menuData).pipe(
      map((data) => {
        console.log('sidebar data', data);
        if(data && data.length > 0 && this.appGlobalService.get('applicationType') != ApplicationTypes.INDEPENDENT){
          return data.filter(dt => dt?.displayName != 'DISCOVER');
        }
        return data;
      })
    );
  }
  toggleChild(event: any) {
    const curTarget = $(event.target);
    if (curTarget.hasClass('metismenu-state-icon')) {
      curTarget.parent().siblings('ul')?.toggleClass('mm-collapse');
      curTarget.parent().children('.caret-left').toggleClass('pe-7s-angle-down');
    } else {
      curTarget.siblings('ul')?.toggleClass('mm-collapse');
      curTarget.children('.caret-left').toggleClass('pe-7s-angle-down');
    }
  }
}
